import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.less']
})
export class UploadFileComponent implements OnInit {
  @Output() nzVoted = new EventEmitter<any>();
  @Input() showUploadList = null;
  @Input() fileList = [];
  @Input() showButton = 0;
  @Input() disabled = 0;
  @Input() url = '';

  previewImage: string | undefined = '';
  previewVisible = false;

  constructor(public msg: NzMessageService) { }

  ngOnInit(): void {
  }
  handlePreview = async (file: NzUploadFile) => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await this.getBase64(file.originFileObj!);
    }
    this.previewImage = file.url || file.preview;
    this.previewVisible = true;
  }
  getBase64(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  handleChange(info: { file: NzUploadFile }): void {
    switch (info.file.status) {
      case 'uploading':
        break;
      case 'done':
        // 上传成功
        this.nzVoted.emit(this.fileList);
        break;
      case 'error':
        this.msg.error('网络错误');
        break;
    }
  }
  handleRemove = ($event: any) => {
    this.nzVoted.emit(this.fileList);
  }
}
